import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4 py-3 h-full flex flex-col" }
const _hoisted_2 = { class: "mb-3 mr-4 flex items-center gap-2" }
const _hoisted_3 = { class: "overflow-auto flex-1" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "inline-block min-w-full align-middle" }
const _hoisted_6 = { class: "py-2 font-semibold text-gray-900 whitespace-nowrap text-left" }
const _hoisted_7 = {
  scope: "col",
  class: "pr-3"
}
const _hoisted_8 = { scope: "col" }
const _hoisted_9 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_10 = { class: "py-2 pr-3 text-gray-600 whitespace-nowrap" }
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = { class: "py-2 text-gray-500" }
const _hoisted_13 = {
  key: 1,
  class: "py-2 text-sm truncate h-full flex flex-col items-center justify-center text-center"
}

import { useCurrentCustomerName, useCurrentSiteId } from "@oculai/planner";
import { format, parseISO } from "date-fns";
import { onMounted, ref } from "vue";
import PlannerRepository from "@/repositories/PlannerRepository";
import logger from "@/services/logger";
import BaseWidget from "@/views/dashboard/componentsV2/BaseWidget.vue";
import DashboardDragHandle from "@/views/dashboard/componentsV2/DashboardDragHandle.vue";
import { normalWidgetWidth } from "@/views/dashboard/composables";
import { ActiveLeafNode } from "@/views/planner/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlannerWidget',
  props: {
    width: {},
    height: {}
  },
  emits: ["delete"],
  setup(__props: any) {




const openLeafNodes = ref<ActiveLeafNode[]>([]);
const isLoading = ref(false);

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();

const getOpenLeafNodesData = () => {
  isLoading.value = true;

  return PlannerRepository.loadActiveLeafNodes(currentCustomerName, currentSiteId)
    .then((data) => {
      openLeafNodes.value = data;
    })
    .catch((error) => {
      if (error?.response?.status !== 404) {
        logger.error(error);
      }
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const joinParents = (parentList: string[], n: number) => {
  const lastNParents = parentList.slice(-n);
  return lastNParents.join(" > ");
};

onMounted(() => {
  getOpenLeafNodesData();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(BaseWidget, {
    isLoading: isLoading.value,
    onDelete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete'))),
    hideDragHandle: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DashboardDragHandle, { class: "shrink-0" }),
          _createVNode(_component_RouterLink, {
            to: {
            name: 'PlannerV2',
            params: {
              customer_name: _unref(currentCustomerName),
              site_id: _unref(currentSiteId),
            },
          },
            class: _normalizeClass(["font-semibold text-gray-900 truncate hover:text-yellow-800", _ctx.width > _unref(normalWidgetWidth) ? 'text-lg' : 'text-base'])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("dashboard.project.planner_card.current_procedures")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (openLeafNodes.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("table", {
                    class: _normalizeClass(["min-w-full divide-y divide-gray-300", _ctx.width > _unref(normalWidgetWidth) ? 'text-sm' : 'text-xs'])
                  }, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_6, [
                        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("dashboard.project.planner_card.procedure")), 1),
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("dashboard.project.planner_card.start_date")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openLeafNodes.value, (node) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: node.id
                        }, [
                          _createElementVNode("td", _hoisted_10, [
                            _createTextVNode(_toDisplayString(`${joinParents(node.parent_names, 2)} / `) + " ", 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(node.name), 1)
                          ]),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(format)(_unref(parseISO)(node.actual_start), "dd.MM.yyyy")), 1)
                        ]))
                      }), 128))
                    ])
                  ], 2)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t("dashboard.project.planner_card.no_current_procedures")), 1))
        ])
      ])
    ]),
    _: 1
  }, 8, ["isLoading"]))
}
}

})